import { render, staticRenderFns } from "./PoweredByAmio.vue?vue&type=template&id=23234d66"
import script from "./PoweredByAmio.vue?vue&type=script&lang=js"
export * from "./PoweredByAmio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports